import moment from 'moment';

const DateHelper = {
    parse(value) {
        if (!value) return null;

        const format = localStorage.getItem('dateformat') || 'DD/MM/YYYY';
        return moment(value, format).toDate();
    },

    format(date) {
        if (!date) return '';

        const format = localStorage.getItem('dateformat') || 'DD/MM/YYYY';
        return moment(date).format(format);
    }
};

export default {
    install(Vue) {
        Vue.prototype.$date = DateHelper;
    }
};